/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ companyName: NonNullable<unknown> }} Faq_Q1_AnswerInputs */

const en_faq_q1_answer = /** @type {(inputs: Faq_Q1_AnswerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.companyName} insurance pays the costs of medical services if you are unexpectedly sick or injured. Without insurance, the cost of medical care in Canada is extremely expensive.`)
};

const fr_faq_q1_answer = /** @type {(inputs: Faq_Q1_AnswerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'assurance ${i?.companyName} paie les frais des services médicaux si vous tombez inopinément malade ou vous blessez. Sans assurance, le coût des soins médicaux au Canada est extrêmement élevé.`)
};

/**
* | output |
* | --- |
* | "{companyName} insurance pays the costs of medical services if you are unexpectedly sick or injured. Without insurance, the cost of medical care in Canada is ..." |
*
* @param {Faq_Q1_AnswerInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const faq_q1_answer = /** @type {((inputs: Faq_Q1_AnswerInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q1_AnswerInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q1_answer(inputs)
	return fr_faq_q1_answer(inputs)
});